import { inject, Pipe, PipeTransform } from '@angular/core';
import { ResinStore } from 'app/core/stores';
import { firstValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'resinName',
  standalone: true,
})
export class ResinNamePipe implements PipeTransform {
  private readonly _resinStore = inject(ResinStore);
  private readonly _translateService = inject(TranslateService);

  async transform(resinId: string): Promise<string> {
    if (!resinId) return '';

    const [dsResins, rwcResins] = await Promise.all([
      firstValueFrom(this._resinStore.dsResinOptions$),
      firstValueFrom(this._resinStore.rwcResinOptions$),
    ]);

    return (
      (dsResins.find(r => r.id === resinId) ?? rwcResins.find(r => r.id === resinId))?.name ??
      this._translateService.instant('general.missingResin')
    );
  }
}
